import React, { useEffect, useState } from "react";
import CountdownClock from "./countdownclock";
import "./dashboard.css";
import GoogleSlides from 'react-google-slides';
import c2 from "../imgComponents/iconos/icono-2.png";
import proximg from "../imgComponents/iconos/apps.png";
import imgpublicidad from "../imgComponents/iconos/AWS.png";
import { arrStorage } from "../main_components/menu/data";
import { cognitoUserData } from "../main_components/tokens/cognito_user_data"; // ajusta la ruta si es necesario

export const DASHBOARD = () => {
    const [expirationDateAcces, setExpirationDateAcces] = useState(null);

    // Obtener fecha de expiración del idToken dinámicamente
    useEffect(() => {
        const fetchTokenExpiration = async () => {
            try {
                const userData = await cognitoUserData();
                if (userData?.tokens?.idToken) {
                    const token = userData.tokens.idToken;
                    const decoded = JSON.parse(atob(token.split('.')[1]));
                    const expiration = new Date(0);
                    expiration.setUTCSeconds(decoded.exp);
                    setExpirationDateAcces(expiration);
                }
            } catch (error) {
                console.error("Error fetching token expiration:", error);
            }
        };

        fetchTokenExpiration();
    }, []);

    const modulos = [
        {
            id: 1,
            modulo: "Centro de Ayuda",
            des: "En este módulo el usuario podrá levantar tickets de soporte y sugerencias de los módulos",
            icono: c2
        },
    ];

    const r = localStorage.getItem("rolesfav");
    const u = localStorage.getItem("userIdfav");
    const arrLocalStorage = arrStorage(r, u);

    const handlehi = () => {
        window.open("https://www.herramientasinformaticas.com", "_blank");
    };

    return (
        <div className='container-dashboard'>
            <div className='welcome-container'>
                <div className='title-dashboard'>
                    BIENVENIDO A OD2
                </div>
            </div>

            <div className='grid-dashboard'>
                <div className='seccion1'>
                    <div className="seccion-noticias">
                        <div className="title-noticias">Nuevas Actualizaciones</div>
                        <div className="presentacion-noticias">
                            <GoogleSlides
                                width="100%"
                                height="310px"
                                slidesLink="https://docs.google.com/presentation/d/1fTaOS84-sR6xUEqbsp35i8D213vsSf0E6LfqC8i0ago/edit#slide=id.p"
                                slideDuration={5}
                                position={1}
                                showControls
                                loop
                            />
                        </div>
                    </div>
                </div>

                <div className='seccion2'>
                    <div className="hi-seccion">
                        <div className="title-hi">Herramientas Informáticas</div>
                        <div className="publicidad-hi">
                            <img src={imgpublicidad} alt="" onClick={handlehi} />
                        </div>
                    </div>
                </div>

                <div className='seccion3'>
                    <div className='token-container'>
                        <div className='token-title'>Tiempo de Sesión</div>
                        <div className='token-time'>
                            {expirationDateAcces ? (
                                <>Tiempo restante: <CountdownClock expirationDateAcces={expirationDateAcces} /></>
                            ) : (
                                <p>Cargando tiempo de sesión...</p>
                            )}
                        </div>
                    </div>

                    <div className="moduls-act">
                        <div className="title-moduls">Nuevos Módulos</div>
                        <div className="moduls-list">
                            {modulos?.map(item => (
                                <div className="cart-modulo" key={item.id}>
                                    <div className="cart-modulo-icon">
                                        <img src={item.icono} alt="" />
                                    </div>
                                    <div className="cart-modulo-title">
                                        <p className="name-modu">{item.modulo}</p>
                                        <p className="description-modu">{item.des}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="seccion4">
                    <div className="title-seccion4">Módulos Favoritos</div>
                    <div className="modulos-fav-star">
                        {arrLocalStorage?.map((valor, index) => {
                            if (!valor.forStorage || valor.restriccion === "none" || valor.restriccion === "DENEGADO") return null;
                            return (
                                <div className={`$carta${index}`} key={index}>
                                    <a href={valor.ruta} className="cartas">
                                        <div className="iconofav">{valor.icono}</div>
                                        <div className="desfav">{valor.name}</div>
                                    </a>
                                </div>
                            );
                        })}
                    </div>
                </div>

                <div className="seccion5">
                    <div className="title-moduls">Próximos Módulos</div>
                    <div className="moduls-list-prox">
                        <div className="img-prox">
                            <img src={proximg} alt="" />
                        </div>
                        <div className="title-prox">Sin Información</div>
                    </div>
                </div>
            </div>
        </div>
    );
};
